export class NotFoundError extends Error {
    readonly kind = 'NotFoundError';
    constructor() {
        super('NotFoundError');
    }
}
